import { render, staticRenderFns } from "./reqRegister.vue?vue&type=template&id=4f611dbf&scoped=true&"
import script from "./reqRegister.vue?vue&type=script&lang=js&"
export * from "./reqRegister.vue?vue&type=script&lang=js&"
import style0 from "./reqRegister.vue?vue&type=style&index=0&id=4f611dbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f611dbf",
  null
  
)

export default component.exports